<template>
  <div class="container">
    <div class="fl w-50 w-25-ns">
      <div href="" class="db aspect-ratio aspect-ratio--1x1 dim">
        <span role="img" style="background-image:url(https://images.unsplash.com/photo-1443219039328-224ed0298799?auto=format&fit=crop&w=1651&q=80);" class="bg-center cover aspect-ratio--object"></span>
      </div>
    </div>
    <div class="fl w-50 w-25-ns">
      <div href="" class="db aspect-ratio aspect-ratio--1x1 dim">
        <span role="img" style="background-image:url(https://images.unsplash.com/photo-1479839672679-a46483c0e7c8?auto=format&fit=crop&w=708&q=80);" class="bg-center cover aspect-ratio--object"></span>
      </div>
    </div>
    <div class="fl w-50 w-25-ns">
      <div href="" class="db aspect-ratio aspect-ratio--1x1 dim">
        <span role="img" style="background-image:url(https://images.unsplash.com/photo-1465804575741-338df8554e02?auto=format&fit=crop&w=1653&q=80);" class="bg-center cover aspect-ratio--object"></span>
      </div>
    </div>
    <div class="fl w-50 w-25-ns">
      <div href="" class="db aspect-ratio aspect-ratio--1x1 dim">
        <span role="img" style="background-image:url(https://images.unsplash.com/photo-1483366774565-c783b9f70e2c?auto=format&fit=crop&w=1650&q=80);" class="bg-center cover aspect-ratio--object"></span>
      </div>
    </div>
    <div class="fl w-50-ns w-100">
      <div href="" class="db aspect-ratio aspect-ratio--1x1 dim">
        <span role="img" style="background-image:url(https://images.unsplash.com/photo-1470274307695-febe05a6dd3d?auto=format&fit=crop&w=2775&q=80);" class="bg-center cover aspect-ratio--object"></span>
      </div>
    </div>
    <div class="fl w-50 w-25-ns">
      <div href="" class="db aspect-ratio aspect-ratio--1x1 dim">
        <span role="img" style="background-image:url(https://images.unsplash.com/photo-1479292889369-1a48f234247e?auto=format&fit=crop&w=1008&q=80);" class="bg-center cover aspect-ratio--object"></span>
      </div>
    </div>
    <div class="fl w-50 w-25-ns">
      <div href="" class="db aspect-ratio aspect-ratio--1x1 dim">
        <span role="img" style="background-image:url(https://images.unsplash.com/photo-1505899823904-b58e10d5231a?auto=format&fit=crop&w=708&q=80);" class="bg-center cover aspect-ratio--object"></span>
      </div>
    </div>
    <div class="fl w-50 w-25-ns">
      <div href="" class="db aspect-ratio aspect-ratio--1x1 dim">
        <span role="img" style="background-image:url(https://images.unsplash.com/photo-1506345285442-8e9a3a298cdd?auto=format&fit=crop&w=1683&q=80);" class="bg-center cover aspect-ratio--object"></span>
      </div>
    </div>
    <div class="fl w-50 w-25-ns">
      <div href="" class="db aspect-ratio aspect-ratio--1x1 dim">
        <span role="img" style="background-image:url(https://images.unsplash.com/photo-1491065879479-c8e4139894ef?auto=format&fit=crop&w=668&q=80);" class="bg-center cover aspect-ratio--object"></span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Works',
  data () {
    return {
    }
  }
}
</script>

<!-- add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Works.vue